module.exports = __webpack_public_path__ + "work_in_progress-a2f6149582e0feab495f29c070cc79b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/components/customer_projects_list/work_in_progress.jpg
// module id = 1145
// module chunks = 2 3